import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';
import { element } from 'prop-types';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/dashboard/one'));
// Users
const Users = lazy(() => import('src/pages/dashboard/users'));
const UsersCreate = lazy(() => import('src/pages/dashboard/usersCreatePage'));
const UserAccountPage = lazy(() => import('src/pages/dashboard/account'));

// Roles
const Roles = lazy(() => import('src/pages/dashboard/roles'));
const RolesCreate = lazy(() => import('src/pages/dashboard/rolesCreatePage'));
// Companies
const Companies = lazy(() => import('src/pages/dashboard/companies'));
const CompaniesCreate = lazy(() => import('src/pages/dashboard/companiesCreatePage'));
// relationRolService
const RelationRolService = lazy(() => import('src/pages/dashboard/RelationRolService'));
// Clients
const Clients = lazy(() => import('src/pages/dashboard/clients'));
const Transactions = lazy(() => import('src/pages/dashboard/transactions'));

// Products
const Products = lazy(() => import('src/pages/dashboard/products'));
const ProductsCreateView = lazy(() => import('src/pages/dashboard/productsCreatePage'));

// Configuracion Fel
const ConfiguracionFel = lazy(() => import('src/pages/dashboard/settingsFel'));
const ConfiguracionFelCreate = lazy(() => import('src/pages/dashboard/settingsFelCreatePage'));

// History
const History = lazy(() => import('src/pages/dashboard/history'));

// Organizacion
const Organization = lazy(() => import('src/pages/dashboard/organization'))
const OrganizationCreate = lazy(()=> import('src/pages/dashboard/organizationCreatePage'))

// Onboarding
const OnBoarding = lazy(()=> import('src/pages/dashboard/onboarding'))
const OnBoardingDetail = lazy(()=> import('src/pages/dashboard/onboardingDetail'))
const OnBoardingCreate = lazy(()=> import('src/pages/dashboard/onboardingCreate'))
// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet /> 
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      {
        path: 'roles',
        children: [
          { element: <Roles />, index: true },
          { path: 'new', element: <RolesCreate /> },
        ],
      },
      {
        path: 'Usuarios',
        children: [
          { element: <Users />, index: true },
          { path: 'new', element: <UsersCreate /> },
          { path: 'account', element:  <UserAccountPage /> },
        ],
      },
      {
        path: 'Empresas',
        children: [
          { element: <Companies />, index: true },
          { path: 'new', element: <CompaniesCreate /> },
        ],
      },
      {
        path: 'Productos',
        children: [
          { element: <Products />, index: true },
          { path: 'new', element: < ProductsCreateView/> },
        ],
      },
      {
        path: 'ConfiguracionFEL',
        children: [
          { element: <ConfiguracionFel />, index: true },
          { path: 'new', element: < ConfiguracionFelCreate/> },
        ],
      },
      {
        path: 'ServicioRol',
        children: [
          { element: <RelationRolService />, index: true },
        ],
      },
      {
        path: 'clientes',
        children: [
          { element: <Clients />, index: true },
        ],
      },
      {
        path: 'transacciones',
        children: [
          { element: <Transactions />, index: true },
        ],
      },
      {
        path: 'historico',
        children: [
          { element: <History />, index: true },
        ],
      },
      {
        path: 'publicas',
        children: [
          { element: <UserAccountPage />, index: true },
        ],
      },
      {
        path: 'Organizaciones',
        children: [
          {element: <Organization/>, index:true},
          { path: 'new', element: < OrganizationCreate/> },
        ]
      },
      {
        path: 'Onboarding',
        children: [
          { element: <OnBoarding />, index: true },
          { path: 'new', element: <OnBoardingCreate /> },
          { path: ':uuid/edit', element: <OnBoardingCreate /> },
          { path: ':uuid/ver', element: <OnBoardingCreate /> },
          { path: ':uuid', element: <OnBoardingDetail /> },
        ]
      }
    ],
  },
];
